<template>
    <div class="workspace-env">
        <hc-form v-loading="loading.dialog" style="margin-left: -10px" :model="form" label-width="110px" label-position="left">
            <hc-form-item label="当前分支" size="small">
                <hc-input :value="current && current.workspaceName" disabled />
            </hc-form-item>
            <hc-form-item label="业务环境" size="small">
                <tree-select
                    :options="evnTypeTree"
                    :value="form.businessEnvId"
                    :props="propsConfig"
                    :clearable="false"
                    :accordion="true"
                    @getValue="getValue($event)"
                />
            </hc-form-item>
        </hc-form>
        <hc-button v-loading="loading.save" :disabled="disabled" type="primary" @click="saveEnv">
            保存
        </hc-button>
    </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import treeSelect from '@common/components/common/tree-select'
import { WORKSPACE } from '@common/store/module-types'
import { GET_ENV_LIST, EDIT_WORKSPACE, GET_WORKSPACE_LIST } from '@common/store/workspace/types'
import { UPDATE_REFRESH_FLAG } from '@common/store/types'
import { getEvnZHName } from '@common/utils/zh'
import { bus } from '@utils/event'

export default {
    name: 'Setting',
    components: {
        treeSelect,
    },
    data() {
        return {
            form: {
                businessEnvId: '',
            },
            // envList: [],
            envData: {},
            loading: {
                save: false,
                dialog: false,
            },

            valueId: '',            // 初始ID（可选）
            options: [],
            propsConfig: {                // 配置项（必选）
                value: 'value',
                label: 'label',
                children: 'children',
            },
        }
    },
    computed: {
        evnTypeTree() {
            const tree = []
            const { envData } = this
            Object.keys(envData).forEach(key => {
                const children = envData[key].map(item => ({
                    label: item.name,
                    value: item.id,
                }))
                tree.push({
                    label: getEvnZHName(key),
                    children,
                })
            })
            return tree
        },
        ...mapState(WORKSPACE, ['current']),
        ...mapState(['refreshFalg']),
        disabled() {
            return !this.form.businessEnvId
        },
    },
    watch: {
        current(val) {
            if (val && val.businessEnvId) {
                this.form.businessEnvId = val.businessEnvId
            }
        },
    },
    created() {
        this.getAllEnvList()
        if (this.current && this.current.businessEnvId) {
            this.form.businessEnvId = this.current.businessEnvId
        }
    },
    methods: {
        ...mapActions(WORKSPACE, {
            getEnvList: GET_ENV_LIST,
            editWorkspace: EDIT_WORKSPACE,
            GET_WORKSPACE_LIST,
        }),
        ...mapMutations({
            UPDATE_REFRESH_FLAG,
        }),
        async getAllEnvList() {
            this.loading.dialog = true
            const { $to } = this
            const { appId } = this.$route.params
            const params = {
                appId,
            }
            const [err, data] = await $to(this.getEnvList(params))

            if (!err) {
                this.envData = data
            }
            this.loading.dialog = false
        },
        getValue(businessEnvId) {
            this.form.businessEnvId = businessEnvId
        },
        async saveEnv() {
            this.loading.save = true
            const { appId, workspaceId } = this.$route.params
            const { businessEnvId } = this.form
            const { $to } = this
            const params = {
                appId,
                workspaceId,
                businessEnvId,
            }
            
            const [err] = await $to(this.editWorkspace(params))

            if (!err) {
                this.GET_WORKSPACE_LIST({ appId, workspaceId })
                this.$message({
                    message: '修改工作区业务环境成功',
                    type: 'success',
                })
                this.$emit('success')
                this.UPDATE_REFRESH_FLAG(true)
                bus.$emit('change_bus_env', { appId, envId: businessEnvId })
            }
            this.loading.save = false
        },
    },
}
</script>

<style lang="less" scoped>
.workspace-env{
  width: 380px;
}
</style>
